import { MiddlewareData } from "@floating-ui/core";

/**
 * Get and apply the arrow coordinates from Floating-UI's useFloating hook
 * @param  {string} data Data from the middleWareData property on useFloating hook
 * @param  {string} arrow Name of Spark's caret position
 * @return {Object}       Name of Spark caret
 */
export const getArrowCoords = (
  data: MiddlewareData,
  arrow: string | undefined
): { top: string; left: string; margin?: string } | undefined => {
  const ARROW_SIZE = 16.97;
  const ARROW_X = data.arrow?.x ?? 0;
  const ARROW_Y = data.arrow?.y ?? 0;
  switch (arrow) {
    case "above":
      return {
        top: "100%",
        left: ARROW_X + ARROW_SIZE / 2 + "px",
        margin: "0 -1px",
      };
    case "below":
      return { top: "0px", left: ARROW_X + ARROW_SIZE / 2 + "px" };
    case "right":
      return { top: ARROW_Y + ARROW_SIZE / 2 + "px", left: "0px" };
    case "left":
      return {
        top: ARROW_Y + ARROW_SIZE / 2 + "px",
        left: "100%",
        margin: "0 -1px",
      };
  }
};
